<template lang="pug">
  .container-login
    .browser-header
      h2 温馨提示：浏览器版本过低
      p 尊敬的用户，系统检测发现您使用的浏览器版本过低，为更好的使用体验，我们建议您升级到最新浏览器。建议使用chrome、firefox浏览器获取最佳体验。
      .btn(@click="ignoreToVisit") 继续访问
    .browser-body
      .chrome 
        .txt chrome
        .btn(@click="visit('https://www.google.cn/chrome/')") 前往下载
      .firefox 
        .txt firefox
        .btn(@click="visit('http://www.firefox.com.cn/')") 前往下载
</template>

<script>
import { goTo } from "../gadgets/tools";
export default {
  name: "browser",
  data() {
    return {};
  },
  computed: {},
  methods: {
    visit(url) {
      console.log(url, goTo);
      goTo(url);
    },
    ignoreToVisit() {
      this.$store.dispatch("BROWSER", { ignore: true });
      let path = this.$route.query.path || "/login";
      console.log(path);
      let query = this.$route.query;
      delete query.path
      this.$router.push({ path, query });
      // this.$router.push({name:})
    },
  },
  mounted() {
    console.log(this.$route);
  },
};
</script>

<style lang="less">
@import (reference) "../assets/general";

.container-login {
  .flex(center, center, column);
  .max-width;
  .max-height;

  background: url("../assets/bg_login.jpg") center center no-repeat;
  background-size: cover;
}
.browser-header {
  width: 600px;
  color: #fff;
  display: flex;
  flex-direction: column;
  h2 {
    text-align: center;
    font-size: 28px;
  }
  p {
    text-indent: 32px;
  }
  .btn {
    border: 1px solid #fff;
    border-radius: 4px;
    width: 64px;
    padding: 10px;
    align-self: flex-end;
    cursor: pointer;
  }
}
.browser-body {
  display: flex;
  flex-direction: row;
  color: #fff;
  .txt {
    margin-top: 138px;
    text-align: center;
    font-size: 18px;
  }
  .btn {
    border: 1px solid #fff;
    border-radius: 4px;
    width: 64px;
    padding: 6px;
    margin-left: 26px;
    cursor: pointer;
  }
}
.chrome {
  width: 128px;
  height: 128px;
  background: url("../assets/chrome.png") center center no-repeat;
  margin-right: 50px;
}
.firefox {
  width: 128px;
  height: 128px;
  background: url("../assets/firefox.png") center center no-repeat;
}
</style>
